import createInterceptor from './Interceptor';

const baseURL = import.meta.env.VITE_DASHBOARD_MGR_API_URL;

const axiosInstance = createInterceptor({
  baseURL,
  withCredentials: true,
});

export default axiosInstance;
